"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsingNavStyled = exports.CollapsingNavAStyled = exports.CollapsingNavLinkIconStyled = exports.CollapsingNavLinksBlockStyled = exports.CollapsingNavLinksListItemStyled = exports.CollapsingNavLinksListStyled = exports.CollapsingNavIconsWrapperStyled = exports.CollapsingNavIconAngleStyled = exports.CollapsingNavIconPlusStyled = exports.CollapsingNavIconMinusStyled = exports.CollapsingNavBodyStyled = exports.CollapsingNavActiveLinkStyled = exports.CollapsingNavHeadingStyled = exports.CollapsingNavTargetStyled = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _button = require("../../../components/button");

var _link = require("../../../components/link");

var _const = require("../../../const");

var _minusThin = _interopRequireDefault(require("../../../icons/minus-thin"));

var _plusThin = _interopRequireDefault(require("../../../icons/plus-thin"));

var _angleThinLeft = _interopRequireDefault(require("../../../icons/angle-thin-left"));

var _theme = _interopRequireDefault(require("./theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CollapsingNavTargetStyled = /*#__PURE__*/(0, _styledComponents.default)(_button.Button).withConfig({
  displayName: "collapsing-navstyled__CollapsingNavTargetStyled",
  componentId: "fxeo5e-0"
})(["border:none;letter-spacing:0;white-space:nowrap;width:100%;", ""], function (_ref) {
  var color = _ref.color;
  return (0, _styledComponents.css)(["&:hover{background-color:", ";}"], _const.Colors[color]);
});
exports.CollapsingNavTargetStyled = CollapsingNavTargetStyled;
var CollapsingNavHeadingStyled = /*#__PURE__*/(0, _styledComponents.default)("h3").withConfig({
  displayName: "collapsing-navstyled__CollapsingNavHeadingStyled",
  componentId: "fxeo5e-1"
})(["", " ", " margin:0;min-width:40%;overflow:hidden;text-align:left;text-transform:lowercase;text-overflow:ellipsis;vertical-align:text-top;"], function (_ref2) {
  var $isAem = _ref2.theme.$isAem;
  return $isAem ? (0, _styledComponents.css)(["font-size:14px;line-height:21px;"]) : (0, _styledComponents.css)(["font-size:16px;line-height:28px;"]);
}, function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive && (0, _styledComponents.css)(["color:", ";"], _const.Colors.primaryDark);
});
exports.CollapsingNavHeadingStyled = CollapsingNavHeadingStyled;
var CollapsingNavActiveLinkStyled = /*#__PURE__*/(0, _styledComponents.default)("span").withConfig({
  displayName: "collapsing-navstyled__CollapsingNavActiveLinkStyled",
  componentId: "fxeo5e-2"
})(["color:", ";display:block;font-size:11px;line-height:19px;text-transform:lowercase;white-space:normal;"], _const.Colors.primaryDark);
exports.CollapsingNavActiveLinkStyled = CollapsingNavActiveLinkStyled;
var CollapsingNavBodyStyled = /*#__PURE__*/(0, _styledComponents.default)("div").withConfig({
  displayName: "collapsing-navstyled__CollapsingNavBodyStyled",
  componentId: "fxeo5e-3"
})(["background-color:", ";left:0;position:absolute;top:100%;text-align:left;width:100%;z-index:10;"], _const.Colors.secondaryLight);
exports.CollapsingNavBodyStyled = CollapsingNavBodyStyled;
var CollapsingNavIconMinusStyled = /*#__PURE__*/(0, _styledComponents.default)(_minusThin.default).withConfig({
  displayName: "collapsing-navstyled__CollapsingNavIconMinusStyled",
  componentId: "fxeo5e-4"
})([""]);
exports.CollapsingNavIconMinusStyled = CollapsingNavIconMinusStyled;
var CollapsingNavIconPlusStyled = /*#__PURE__*/(0, _styledComponents.default)(_plusThin.default).withConfig({
  displayName: "collapsing-navstyled__CollapsingNavIconPlusStyled",
  componentId: "fxeo5e-5"
})([""]);
exports.CollapsingNavIconPlusStyled = CollapsingNavIconPlusStyled;
var CollapsingNavIconAngleStyled = /*#__PURE__*/(0, _styledComponents.default)(_angleThinLeft.default).withConfig({
  displayName: "collapsing-navstyled__CollapsingNavIconAngleStyled",
  componentId: "fxeo5e-6"
})(["transform:rotate(-90deg);transition:transform ease-out 0.3s;"]);
exports.CollapsingNavIconAngleStyled = CollapsingNavIconAngleStyled;
var CollapsingNavIconsWrapperStyled = /*#__PURE__*/(0, _styledComponents.default)("div").withConfig({
  displayName: "collapsing-navstyled__CollapsingNavIconsWrapperStyled",
  componentId: "fxeo5e-7"
})(["margin-left:15px;position:relative;", " ", ",", "{left:0;position:absolute;top:0;transition:opacity ease-out 0.3s,visibility ease-out 0.3s,transform ease-out 0.3s;}", "{opacity:0;visibility:hidden;}", ""], function (_ref4) {
  var $isAem = _ref4.theme.$isAem;
  return $isAem ? (0, _styledComponents.css)(["height:14px;width:8px;"]) : (0, _styledComponents.css)(["height:11px;width:11px;"]);
}, CollapsingNavIconMinusStyled, CollapsingNavIconPlusStyled, CollapsingNavIconMinusStyled, function (_ref5) {
  var active = _ref5.active;
  return active && (0, _styledComponents.css)(["", "{opacity:0;visibility:hidden;transform:rotate(90deg);}", "{opacity:1;visibility:visible;}", "{transform:rotate(90deg);}"], CollapsingNavIconPlusStyled, CollapsingNavIconMinusStyled, CollapsingNavIconAngleStyled);
});
exports.CollapsingNavIconsWrapperStyled = CollapsingNavIconsWrapperStyled;
var CollapsingNavLinksListStyled = /*#__PURE__*/(0, _styledComponents.default)("ul").withConfig({
  displayName: "collapsing-navstyled__CollapsingNavLinksListStyled",
  componentId: "fxeo5e-8"
})(["list-style-type:none;margin:0;", ""], function (_ref6) {
  var $isAem = _ref6.theme.$isAem;
  return $isAem ? (0, _styledComponents.css)(["padding:0;"]) : (0, _styledComponents.css)(["padding:0 39px 18px;&:first-child{padding-top:18px;}"]);
});
exports.CollapsingNavLinksListStyled = CollapsingNavLinksListStyled;
var CollapsingNavLinksListItemStyled = /*#__PURE__*/(0, _styledComponents.default)("li").withConfig({
  displayName: "collapsing-navstyled__CollapsingNavLinksListItemStyled",
  componentId: "fxeo5e-9"
})(["", ""], function (_ref7) {
  var $isAem = _ref7.theme.$isAem;
  return $isAem ? (0, _styledComponents.css)(["font-size:12px;font-weight:300;line-height:18px;padding:15px;&:not(:last-of-type){border-bottom:1px solid ", ";}"], _const.Colors.secondary) : (0, _styledComponents.css)(["font-size:11px;font-weight:400;line-height:19px;&:not(:last-of-type){margin-bottom:6px;}"]);
});
exports.CollapsingNavLinksListItemStyled = CollapsingNavLinksListItemStyled;
var CollapsingNavLinksBlockStyled = /*#__PURE__*/(0, _styledComponents.default)("div").withConfig({
  displayName: "collapsing-navstyled__CollapsingNavLinksBlockStyled",
  componentId: "fxeo5e-10"
})(["", ""], function (_ref8) {
  var $isAem = _ref8.theme.$isAem;
  return (0, _styledComponents.css)(["&:first-of-type{border-top:1px solid ", ";}&:not(:last-of-type){border-bottom:1px solid ", ";}"], $isAem ? _const.Colors.secondary : _const.Colors.gray600, $isAem ? _const.Colors.secondary : _const.Colors.gray600);
});
exports.CollapsingNavLinksBlockStyled = CollapsingNavLinksBlockStyled;
var CollapsingNavLinkIconStyled = /*#__PURE__*/(0, _styledComponents.default)("span").withConfig({
  displayName: "collapsing-navstyled__CollapsingNavLinkIconStyled",
  componentId: "fxeo5e-11"
})(["min-width:20px;"]);
exports.CollapsingNavLinkIconStyled = CollapsingNavLinkIconStyled;
var CollapsingNavAStyled = /*#__PURE__*/(0, _styledComponents.default)(_link.A).withConfig({
  displayName: "collapsing-navstyled__CollapsingNavAStyled",
  componentId: "fxeo5e-12"
})(["display:inline-flex;color:", ";text-decoration:none;&:visited{color:", ";}"], _const.Colors.gray800, _const.Colors.gray800);
exports.CollapsingNavAStyled = CollapsingNavAStyled;
var CollapsingNavStyled = /*#__PURE__*/(0, _styledComponents.default)("div").withConfig({
  displayName: "collapsing-navstyled__CollapsingNavStyled",
  componentId: "fxeo5e-13"
})(["position:relative;", ""], function (_ref9) {
  var $theme = _ref9.theme.$theme;
  return (0, _theme.default)($theme);
});
exports.CollapsingNavStyled = CollapsingNavStyled;